import {
  BoxAction,
  BoxIcon,
  Cell,
  EndDateCell,
  Header,
  JobNameCell,
  StartDateCell,
} from 'shared/components/planner/common/utils';
import type { Column } from 'react-table';
import { TFunctionNonStrict } from 'i18next';
import { CandidatePlacementsCellWithTooltip } from 'shared/components/planner/shifts/placements-tooltip/candidate-placements-cell-with-tooltip';
import {
  HqProjectPlanningCellProp,
  HqProjectPlanningColumnDefinition,
} from '../project-planning-table.types';
import { IconIsolationMode } from '../../../../../../../assets/img';
import { ApplicationsCellWithTooltip } from '../../../common/applications-tooltip/applications-cell-with-tooltip';

const getProjectPlanningColumnDefinition: (
  t: TFunctionNonStrict<'hq-screen-specific', undefined>
) => Column<HqProjectPlanningColumnDefinition>[] = (t) => {
  const ActionCell = (props: HqProjectPlanningCellProp<'action'>) => {
    return (
      <BoxAction>
        <BoxIcon>
          <IconIsolationMode
            onClick={() => props.onShowDetail(props.value)}
            data-testid="action-button"
          />
        </BoxIcon>
      </BoxAction>
    );
  };

  const jobName = {
    Header: () => (
      <Header>{t('projects.table_headers.job_title', { ns: 'hq-screen-specific' })}</Header>
    ),
    accessor: 'jobName',
    Cell: JobNameCell,
    width: '200px',
  } as Column<HqProjectPlanningColumnDefinition>;
  const companyName = {
    Header: () => (
      <Header>{t('projects.table_headers.company', { ns: 'hq-screen-specific' })}</Header>
    ),
    accessor: 'companyName',
    Cell: Cell,
    width: '200px',
  } as Column<HqProjectPlanningColumnDefinition>;
  const departmentName = {
    Header: () => (
      <Header>{t('projects.table_headers.department', { ns: 'hq-screen-specific' })}</Header>
    ),
    accessor: 'departmentName',
    Cell: Cell,
    width: '200px',
  } as Column<HqProjectPlanningColumnDefinition>;
  const fromDate = {
    Header: () => (
      <Header>{t('projects.table_headers.from_date', { ns: 'hq-screen-specific' })}</Header>
    ),
    accessor: 'fromDate',
    Cell: StartDateCell,
    width: '115px',
  } as Column<HqProjectPlanningColumnDefinition>;
  const endDate = {
    Header: () => (
      <Header>{t('projects.table_headers.to_date', { ns: 'hq-screen-specific' })}</Header>
    ),
    accessor: 'toDate',
    Cell: EndDateCell,
    width: '115px',
  } as Column<HqProjectPlanningColumnDefinition>;
  const candidatePlacements = {
    Header: () => (
      <Header>{t('projects.table_headers.placements', { ns: 'hq-screen-specific' })}</Header>
    ),
    accessor: 'candidatePlacements',
    Cell: CandidatePlacementsCell,
    width: '110px',
    align: 'center',
  } as Column<HqProjectPlanningColumnDefinition>;
  const applications = {
    Header: () => (
      <Header>{t('projects.table_headers.applications', { ns: 'hq-screen-specific' })}</Header>
    ),
    accessor: 'applications',
    Cell: ApplicationsCell,
    width: '150px',
  } as Column<HqProjectPlanningColumnDefinition>;
  const action = {
    Header: () => (
      <Header>{t('projects.table_headers.action', { ns: 'hq-screen-specific' })}</Header>
    ),
    accessor: 'action',
    Cell: ActionCell,
    width: '65px',
  } as Column<HqProjectPlanningColumnDefinition>;

  return [
    jobName,
    companyName,
    departmentName,
    fromDate,
    endDate,
    candidatePlacements,
    applications,
    action,
  ];
};

const CandidatePlacementsCell = (props: HqProjectPlanningCellProp<'candidatePlacements'>) => {
  return <CandidatePlacementsCellWithTooltip {...props} />;
};

const ApplicationsCell = (props: HqProjectPlanningCellProp<'applications'>) => {
  return <ApplicationsCellWithTooltip {...props} />;
};

export { getProjectPlanningColumnDefinition };
